/**
 * @module getClientConfigurationFromCache
 */

import { getItem } from 'owa-local-storage';
import doesClientConfigurationExistInCache from '../utils/doesClientConfigurationExistInCache';
import { CLIENT_CONFIGURATION_LOCAL_STORAGE_KEY } from '../constants';

/**
 * @function
 * To retrieve the client configuration from the long term cache
 * @returns the client configuration
 */

const getClientConfigurationFromCache = () => {
    if (!doesClientConfigurationExistInCache()) {
        return null;
    }
    return JSON.parse(getItem(window, CLIENT_CONFIGURATION_LOCAL_STORAGE_KEY));
};

export default getClientConfigurationFromCache;
